import React from 'react';
import EducatorStudentToggle from './EducatorStudentToggle';
import HomeGreeting from './HomeGreeting';
import HomeSpacesSection from './HomeSpacesSection';
import { Icons } from '@ublend-npm/aulaui-core';
import ManageWidget from './widgets/manageWidget';

const widgetsLibrary = [
  {
    id: 'widget-000',
    component: <HomeGreeting />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Greeting',
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'widget-001',
    component: (
      <>
        <EducatorStudentToggle />
        <HomeSpacesSection />
      </>
    ),
    icon: <Icons.AssignmentOutlined />,
    title: 'Space',
    size: { lg: 12, md: 12, xs: 12 },
  },
  {
    id: 'widget-009',
    component: <ManageWidget />,
    icon: <Icons.AssignmentOutlined />,
    title: 'Manage Widgets',
    size: { lg: 4, md: 6, xs: 12 },
  },
];

export default widgetsLibrary;
